import { createFileRoute } from '@tanstack/react-router'
import { noop } from '@tanstack/react-query'
import { trpc } from '@/main'

// Pathless layout that OWNS the status-keyed errors list, so switching active / ignored / resolved re-keys THIS match
// and not the page above it — which paints its skeleton at `pendingMs: 0` and would take the status tabs with it. No
// component: nothing to code-split, nothing painted on a re-key. The page reads it with `useMatch({ from })`.
export const Route = createFileRoute('/_app/dev-resources/errors/_list')({
  loaderDeps: ({ search }) => ({ errorStatus: search.errorStatus }),
  context: ({ deps }) => ({
    errorsQueryOptions: trpc.admin.listErrors.queryOptions({ status: deps.errorStatus }),
  }),
  loader: ({ context }) => {
    context.queryClient.query(context.errorsQueryOptions).catch(noop)
  },
})
